import { render, staticRenderFns } from "./OpportunityDashboardLossReasons.vue?vue&type=template&id=199ecc50&scoped=true&"
import script from "./OpportunityDashboardLossReasons.vue?vue&type=script&lang=js&"
export * from "./OpportunityDashboardLossReasons.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDashboardLossReasons.vue?vue&type=style&index=0&id=199ecc50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ecc50",
  null
  
)

export default component.exports